import type { ReactNode } from 'react';

export const symbol_toggle_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M280-240q-100 0-170-70T40-480q0-100 70-170t170-70h400q100 0 170 70t70 170q0 100-70 170t-170 70H280Zm0-60h400q75 0 127.5-52.5T860-480q0-75-52.5-127.5T680-660H280q-75 0-127.5 52.5T100-480q0 75 52.5 127.5T280-300Zm70.5-108.5Q380-438 380-480t-29.5-71.5Q321-581 279-581t-71.5 29.5Q178-522 178-480t29.5 71.5Q237-379 279-379t71.5-29.5ZM480-480Z"
		/>
	</svg>
);
